var map = {
	"./after_1.jpg": 9583,
	"./after_2.jpg": 5968,
	"./after_3.jpg": 5197,
	"./before_1.jpg": 1952,
	"./before_2.png": 3263,
	"./before_3.jpg": 1282,
	"./before_4.jpg": 9297
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2181;